import axios, { AxiosError } from "axios";
import { useMutation, UseMutationOptions } from "react-query";

import { CallDetailResultFromAPI, EventCode } from "../types";
import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { CREATE_CALL_API } from "./constants";

export interface CreateCallResponse extends CallDetailResultFromAPI {}

interface CreateCallRequestProps {
  account: string;
  eventCode: EventCode;
  amount: number;
  tradeDate: string;
  issueDate: string;
  dueDate: string;
}

export const useCreateCall = (
  options: UseMutationOptions<
    CreateCallResponse,
    AxiosError<{ errorDescription: string }>,
    {}
  >
) => {
  const createCallUrl = `${getAppConfigSetting("apiUrl")}${CREATE_CALL_API}`;

  const createCall = async (requestBody: CreateCallRequestProps) => {
    const { data } = await axios(createCallUrl, {
      method: "post",
      withCredentials: true,
      data: requestBody,
    });
    return { ...data };
  };

  return useMutation(createCall, {
    retry: false,
    ...options,
  });
};
